// extracted by mini-css-extract-plugin
export var container = "_ls-0";
export var dotAnimation = "_ls-2";
export var dotsLoading = "_ls-1";